import { enUS, es, fr, it, de, pl, zhCN, ja, ko } from "date-fns/locale";
import type { Locale } from "@/lib/i18n/config";
import { LOCALE_BCP47, resolveLocale } from "@/lib/i18n/config";

const DATE_FNS_LOCALES = {
  en: enUS,
  fr,
  es,
  it,
  de,
  pl,
  zh: zhCN,
  ja,
  ko,
} as const;

export function getDateFnsLocale(locale: string) {
  return DATE_FNS_LOCALES[resolveLocale(locale)];
}

export function getBcp47Locale(locale: string) {
  return LOCALE_BCP47[resolveLocale(locale)];
}

export function formatMoney(
  amount: number,
  currency: string | null,
  locale: string
) {
  const c = (currency || "EUR").toUpperCase();
  try {
    return new Intl.NumberFormat(getBcp47Locale(locale), {
      style: "currency",
      currency: c,
    }).format(amount);
  } catch {
    return `€${amount.toFixed(2)}`;
  }
}

export const LOCALE_GREETING: Record<Locale, string> = {
  en: "Hi",
  fr: "Bonjour",
  es: "Hola",
  it: "Ciao",
  de: "Hallo",
  pl: "Cześć",
  zh: "你好",
  ja: "こんにちは",
  ko: "안녕하세요",
};

export const LOCALE_EMAIL_SIGNOFF: Record<Locale, string> = {
  en: "Thanks for using Kraahl",
  fr: "Merci d'utiliser Kraahl",
  es: "Gracias por usar Kraahl",
  it: "Grazie per aver scelto Kraahl",
  de: "Danke, dass du Kraahl nutzt",
  pl: "Dziękujemy za korzystanie z Kraahl",
  zh: "感谢您使用 Kraahl",
  ja: "Kraahlをご利用いただきありがとうございます",
  ko: "Kraahl을 이용해 주셔서 감사합니다",
};

export const LOCALE_OFFERS_CTA: Record<Locale, string> = {
  en: "View offers",
  fr: "Voir les offres",
  es: "Ver ofertas",
  it: "Vedi offerte",
  de: "Angebote ansehen",
  pl: "Zobacz oferty",
  zh: "查看报价",
  ja: "オファーを見る",
  ko: "제안 보기",
};
